import React from 'react';
import RoundCheckbox from './components/RoundCheckbox';
import RefundItemAccordion from './components/RefundItemAccordion';
import styles from "../../styles.module.scss";
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import { SECURITY_REFUND } from '../../utils';
import SubTypeRefundDetailsForm from './components/SubTypeRefundDetailsForm';
import DownloadSupportingDoc from './components/DownloadSupportingDoc';

const SecurityRefundItem = ({
    payableRefundInfo,
    selectedRefundItems,
    refundItemCheckboxHandler,
    refundDetailsForm,
    handleRefundDetailsForm,
    isConcessionRefund,
    isFullRefund,
    refundReasons,
    viewOnly,
    isLoanCase,
    setLoading, 
    forRefundEdit
}) => {

    
    const { totalRefundableAmount } = payableRefundInfo?.[SECURITY_REFUND] ?? {};

    const isDisabled = (isConcessionRefund || isFullRefund || !totalRefundableAmount);

    const isSelected = selectedRefundItems?.includes(SECURITY_REFUND);

    const handleCheckboxChange = checked => {
        refundItemCheckboxHandler(SECURITY_REFUND, checked);
        if(checked){
            handleRefundDetailsForm("payableToParent", totalRefundableAmount, SECURITY_REFUND);
        }
    }

    const enableItemSelection = !viewOnly && !forRefundEdit;

    return (
        <RefundItemAccordion
            isDisabled={isDisabled}
        >
            <div className='d-flex align-items-center'>

                {
                    enableItemSelection &&
                    <RoundCheckbox
                        isChecked={isSelected}
                        onChange={handleCheckboxChange}
                        isDisabled={isDisabled}
                    />
                }

                <div className={`${styles['accordion-title']} mr-1`}>Security •</div>

                <div className={`${styles['amount']}`}>{formattedPrice(totalRefundableAmount)}</div>
                <div className='d-flex ml-auto'>
                    <DownloadSupportingDoc
                        isDisabled={isDisabled}
                        isSelected={isSelected}
                        refundDetailsForm={refundDetailsForm}
                        refundSubType={SECURITY_REFUND}
                        isLoanCase={false}
                        setLoading={setLoading}
                    />

                </div>
            </div>


            <SubTypeRefundDetailsForm
                refundItemName={SECURITY_REFUND}
                form={refundDetailsForm}
                formHandler={handleRefundDetailsForm}
                amountFieldRequired
                isDisabled={(isDisabled || !isSelected || viewOnly)}
                reasonsDropdownData={refundReasons?.[SECURITY_REFUND]}
                maxRefundAmount={totalRefundableAmount}
                isLoanCase={false} //whole security amount goes to parent
                disableAmountFields
            />

        </RefundItemAccordion>

    );
}

export default SecurityRefundItem;